<template>
	<panel title="Feszültségmentesítések">
		<b-overlay :show="user.role_id == 7 && task.operator_id != user.id && isolations.length != 0" rounded="sm" opacity="0.4">
			<Loading v-if="isolations === false" title="Feszültségmentesítések betöltése"></Loading>
			<NoRecords v-else-if="isolations.length == 0" title="Nincsenek feszültségmentesítések" main_icon="fa fa-bolt"></NoRecords>
			<div v-else>
				<div class="overflow-auto mb-3" style="max-height: 600px">
					<IsolationCard
						v-for="(isolation, id) in isolations_local"
						:key="id"
						:isolation="isolation"
						:edit="user.role_id == 7"
						:electricians="isolation.is_high_voltage == 1 ? electricians_high_voltage : electricians"
						@electricianselected="electricianSelected($event, isolation)"></IsolationCard>
				</div>
				<!-- <div class="text-end" v-if="user.role_id == 7">
								<button class="btn btn-success" @click="setElectricians()"><i class="fa fa-save"></i> Mentés</button>
							</div> -->
			</div>
			<template #overlay>
				<div class="text-center">
					<h3><i class="fa fa-exclamation-triangle"></i></h3>
					<strong>Nem te vagy a hozzárendelt operátor</strong>
				</div>
			</template>
		</b-overlay>
	</panel>
</template>

<script>
import Loading from "@/components/Loading";
import NoRecords from "@/components/NoRecords";
import IsolationCard from "@/components/IsolationCard";
import Task from "@/apis/Task";

export default {
	components: {
		Loading,
		NoRecords,
		IsolationCard,
	},
	props: ["isolations", "electricians", "electricians_high_voltage", "task"],
	data() {
		return {
			isolations_local: this.isolations,
		};
	},
	watch: {
		isolations: {
			handler(val) {
				this.isolations_local = val;
                this.$forceUpdate(this.isolations_local);
			},
			deep: true,
		},
	},
	computed: {
		user() {
			return this.$store.state.user;
		},
	},
	methods: {
		electricianSelected(event, isolation) {
			console.log(event, isolation);
			if (event.user_id != null) {
				console.log('nemnull');
				this.isolations_local.forEach((isolation_record) => {
					if (
						isolation_record.id != isolation.id &&
						isolation_record.user_id == null &&
						isolation_record.is_high_voltage == isolation.is_high_voltage
					) {
						console.log('beállítás');
						Task.setElectricians(this.task.id, { id: isolation_record.id, user_id: event.user_id }).then(() => {
							this.$set(isolation_record, "user_id", event.user_id);
						});
					}
				});
				Task.setElectricians(this.task.id, { id: isolation.id, user_id: event.user_id }).then(() => {
					this.$set(isolation, "user_id", event.user_id);
					this.$set(isolation, "user_name", this.electricians.find(e => e.id == event.user_id).name);
                    this.$forceUpdate(isolation);
				});
			} else {
				this.$set(isolation, "user_id", event.user_id);
                this.$set(isolation, "user_name", this.electricians.find(e => e.id == event.user_id).name);
                this.$forceUpdate(isolation);
			}
		},
	},
};
</script>
